/**
 * Application root module that defines entry components to be initialized.
 */

import { HttpClientModule } from "@angular/common/http";
import { ApplicationRef, ComponentFactoryResolver, NgModule, Type } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AdvancedSearchComponent } from "./advanced-search/advanced-search.component";
import { AdvancedSearchModule } from "./advanced-search/advanced-search.module";

const entryComponents = [
    AdvancedSearchComponent
];

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        AdvancedSearchModule
    ],
    entryComponents: entryComponents
})
export class AppModule {
    public constructor(private _resolver: ComponentFactoryResolver) {
    }

    public ngDoBootstrap(applicationRef: ApplicationRef): void {
        entryComponents.forEach((componentDef: Type<{}>) => {
            const componentFactory = this._resolver.resolveComponentFactory(componentDef);
            if (document.querySelector(componentFactory.selector)) {
                applicationRef.bootstrap(componentFactory);
            }
        });
    }
}
